// extracted by mini-css-extract-plugin
module.exports = {"containerLot":"Toolbox_containerLot__7oqtb","lotNumber":"Toolbox_lotNumber__3KVp5"};